














import Vue from "vue";
import CustomSimulationFilter from "@/features/custom-simulation/filter.vue";
import SimulationItem from "@/features/custom-simulation/simulation-item.vue";
import { Simulation } from "@/api/custom-simulation";

export default Vue.extend({
    components: { CustomSimulationFilter, SimulationItem },
    computed: {
        simulationList(): Simulation[] {
            return this.$store.state.customSimulationModule.simulationList;
        },
        loading(): boolean {
            return this.$store.state.customSimulationModule.simulationListLoading;
        }
    },
    mounted() {
        this.$store.dispatch("customSimulationModule/getSimulationList", {});
    }
});
